import { post } from '../index';

export const assignUserToBrand= data => {
  return post('/brands/share', data);
};
